<template>
<!-- 2张图样式（带文字） -->
  <div
    id="twoPicWord"
    class="twoPicWord"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
  >
  <div class="title">{{tbInfo.title}}</div>
  <div class="content">{{tbInfo.content}}</div>
  <div class="twoPic">
    <div  class="left child-pic" 
    >
          <img @click="goLink(tbInfo.link1)" :src="tbInfo.image1"  class="pic" :class="tbInfo.link1?'link':''"/>
    </div>
    <div  class="right child-pic" 
    >
          <img @click="goLink(tbInfo.link2)" :src="tbInfo.image2"  class="pic" :class="tbInfo.link2?'link':''"/>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "twoPicWord",
  data() {
    return {
      loading: false
    };
  },
  props: ["tbInfo","backgroundPic"],
  methods: {
    // 跳转链接
    goLink(link){
      if(link){
         window.open(link)
      }
    }
  },
  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.twoPicWord {
  width: auto;
  height: 100%;
  background-position: center;
  background-size: cover;
  color: #222;
  display: flex;
  flex-direction: column;
  padding: 0 60px;
  position: relative;
}
.twoPicWord .title{
  font-size: 32px;
  font-weight: 700;
  color: #222;
  text-align: left;
  margin-top: 40px;
}

.twoPicWord .sub-title{
  font-size: 20px;  
  /* white-space: pre; */
  word-break: break-all;
  margin-top: 10px;
}

.twoPicWord .content{
  font-size:18px;
  word-break: break-all;
  margin-top: 10px;
  white-space: pre-wrap;
}
.twoPic {
  width: 100%;
  height: 282px;
  color: #222;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  margin-top: 20px;
  box-sizing: border-box;
  /* padding: 20px 115px 20px 0px;
  position: absolute;
  bottom: 30px; */
}
.twoPicWord .child-pic{
  flex:1;
  height: 100%;
  display: flex;
  /* justify-content: center; */
}
.twoPicWord .left{
  justify-content: left;
}
.twoPicWord .right{
  justify-content: right;
}
.twoPicWord .child-pic img{
  width: 462px;
  height: 270px;
  -o-object-fit: cover;
  object-fit: cover;
}

.twoPicWord .child-pic .link{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/twoPicWord.vue